/*=========================================================================================
  File Name: module-licenseinfo-getters.js
  Description: LicenseInfo Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/

import commonFunc from '@/common/commonFunction';
import moment from 'moment';

export default {
	LicenseInfo: state => {
		return state.LicenseInfo;
	},
	Config: state => {
		return state.Config;
	},
	CurrentDate: state => {
		try {
			let currentDate = state.Config && state.Config.CurrentDate ? state.Config.CurrentDate : new Date();
			if (currentDate instanceof Date) {
				return currentDate;
			} else {
				return moment(currentDate).toDate();
			}
		} catch (ex) {
			console.log('Lỗi hàm chuyển đổi lỗi ngày hiện tại' + ex);
		}
		return new Date();
	},
	LicenseWarning: state => {
		return state.LicenseWarning.Data;
	},
	LicenseInfoNotification: state => {
		return state.LicenseInfoNotification;
	}
};
